module.exports = __webpack_public_path__ + "static/img/project04.28b2d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project04.png
// module id = B8FM
// module chunks = 1